/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Injector } from '@angular/core';
import { type Command, type PromptConfigFull, DeleteAbstract } from '@dm/core';
import { type HomedirRule } from 'app/common/types/mo';

import { CifsShareStrService } from '../../cifs-share-str.service';
import { HomedirRuleCifsShareService } from './../homedir-rule-cifs-share.service';

@Component({
    selector: 'app-remove-homedir-rule-cifs-share',
    templateUrl: './remove-homedir-rule-cifs-share.component.html',
    styleUrls: ['./remove-homedir-rule-cifs-share.component.scss'],
})
export class RemoveHomedirRuleCifsShareComponent extends DeleteAbstract<HomedirRule> {
    i18n = this.str.i18n;

    constructor(
        injector: Injector,
        private str: CifsShareStrService,
        private service: HomedirRuleCifsShareService,
    ) {
        super(injector);
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'NAME',
                header: this.i18n.label.userName,
                className: ['table-cell-text-pre'],
            },
            {
                field: 'fsPath',
                header: this.i18n.label.share_path,
            },
        ];
    }

    prompt(): PromptConfigFull[] {
        const prompts: PromptConfigFull[] = [
            {
                id: 'prompt-removbe-homedir-rule-cifs-share-setHomedirRule',
                canHidden: true,
                opType: 'warning',
                title: this.i18n.title.removeMappingRule,
                content: this.i18n.highRisk.setHomedirRule,
                templateRef: this.tableTemplate,
                width: 700,
            },
        ];

        return prompts;
    }

    buildCmds(): Command[] {
        const cmds: Command[] = this.dataList.map((a) => ({
            name: this.i18n.rest.homedir.removeRule,
            nameParams: [a.NAME, a.fsPath],
            action: this.service.remove(a.ID, a.vstoreId),
        }));

        return cmds;
    }
}
